import { dspxDiffDays } from './dspx-utils';
import moment from 'moment';

const normalizeStr = (str) => str?.toUpperCase().trim() || '';

export const dspxSorter = {

    sorterDocAddressAsc : (a, b) => {
        const aaddr = a.clientAddress ? a.clientAddress.fullAddress : ''
        const baddr = b.clientAddress ? b.clientAddress.fullAddress : ''
        return aaddr.localeCompare(baddr)
    },
    sorterDocAddressDesc : (a, b) => {
        const aaddr = a.clientAddress ? a.clientAddress.fullAddress : ''
        const baddr = b.clientAddress ? b.clientAddress.fullAddress : ''
        return baddr.localeCompare(aaddr)
    },

    sorterDocExecuterAsc : (a, b) => {
        const sa = a.appointedWorker ? a.appointedWorker.fullName : '';
        const sb = b.appointedWorker ? b.appointedWorker.fullName : '';
        return sa.localeCompare(sb);
    },
    sorterDocExecuterDesc : (a, b) => {
        const sa = a.appointedWorker ? a.appointedWorker.fullName : '';
        const sb = b.appointedWorker ? b.appointedWorker.fullName : '';
        return sb.localeCompare(sa);
    },
    sorterResponsibleWorkerAsc : (a, b) => {
        const sa = a.responsibleWorker ? a.responsibleWorker.fullName : '';
        const sb = b.responsibleWorker ? b.responsibleWorker.fullName : '';
        return sa.localeCompare(sb);
    },
    sorterResponsibleWorkerDesc : (a, b) => {
        const sa = a.responsibleWorker ? a.responsibleWorker.fullName : '';
        const sb = b.responsibleWorker ? b.responsibleWorker.fullName : '';
        return sb.localeCompare(sa);
    },

    sorterDocAuthorAsc : (a, b) => {
        const sa = a.createUser ? a.createUser.fullName : '';
        const sb = b.createUser ? b.createUser.fullName : '';
        return sa.localeCompare(sb);
    },
    sorterDocAuthorDesc : (a, b) => {
        const sa = a.createUser ? a.createUser.fullName : '';
        const sb = b.createUser ? b.createUser.fullName : '';
        return sb.localeCompare(sa);
    },


    sorterDocDateAsc: (a, b) => {
        return a.docDate.localeCompare(b.docDate)
    },

    sorterDocDateDesc : (a, b) => {
        return b.docDate.localeCompare(a.docDate)
    },

    sorterDocNumberAsc: (a, b) => {
        if(a.type.id != b.type.id) return a.type.id - b.type.id;
        if(a.type.id == 1 || a.type.id == 4) {
            const na = a.docNumber.substring(a.docNumber.indexOf('/')+1)
            const nb = b.docNumber.substring(b.docNumber.indexOf('/')+1)
            return na - nb
        }
        else if(a.type.id == 2) {
            return a.inNumber - b.inNumber
        }
        else if(a.type.id == 3) {
            return a.docNumber - b.docNumber
        }
    },

    sorterDocNumberDesc: (a, b) => {
        if(a.type.id != b.type.id) return b.type.id - a.type.id;
        if(a.type.id == 1 || a.type.id == 4) {
            const na = a.docNumber.substring(a.docNumber.indexOf('/')+1)
            const nb = b.docNumber.substring(b.docNumber.indexOf('/')+1)
            return nb - na
        }
        else if(a.type.id == 2) {
            return b.inNumber - a.inNumber
        }
        else if(a.type.id == 3) {
            return b.docNumber - a.docNumber
        }
    },

    sorterTypeAsc : (a, b) => {
        return a.type.id - b.type.id;
    },
    sorterTypeDesc : (a, b) => {
        return b.type.id - a.type.id;
    },

    sorterTopicIdAsc : (a, b) => {
        return a.topicId - b.topicId;
    },
    sorterTopicIdDesc : (a, b) => {
        return b.topicId - a.topicId;
    },

    sorterStatusDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.statusOrder - a.statusOrder
    },    
    sorterStatusAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return a.statusOrder - b.statusOrder
    },

    sorterCreateDateDesc: (a, b) => {
        const dateA = a?.createDate || '';
        const dateB = b?.createDate || '';
        return dateB.localeCompare(dateA);
    },
    sorterCreateDateAsc: (a, b) => {
        const dateA = a?.createDate || '';
        const dateB = b?.createDate || '';
        return dateA.localeCompare(dateB);
    },

    sorterDoneDateDesc: (a, b) => {
    const aDate = a.doneDate || '';
    const bDate = b.doneDate || '';

    return bDate.localeCompare(aDate);
    },

    sorterDoneDateAsc: (a, b) => {
    const aDate = a.doneDate || '';
    const bDate = b.doneDate || '';

    return aDate.localeCompare(bDate);
    },


    sorterDeadlineDateDesc : (a, b) => {
        const aDate = a.deadlineDate || '';
        const bDate = b.deadlineDate || '';

        return bDate.localeCompare(aDate);
    },    
    sorterDeadlineDateAsc : (a, b) => {
        const aDate = a.deadlineDate || '';
        const bDate = b.deadlineDate || '';

        return aDate.localeCompare(bDate);
    },


    sorterDateDesc : (a, b) => {
        return b.date.localeCompare(a.date)
    },

    sorterIdAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return a.id - b.id;
    },
    sorterIdDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.id - a.id;
    },

    sorterAgeAsc : (a, b) => {        
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;        
        const dfa = a.statusId == 4 ? 0 : dspxDiffDays(a.doneDate, a.createTime) 
        const dfb = b.statusId == 4 ? 0 : dspxDiffDays(b.doneDate, b.createTime) 
        return  dfa - dfb
    },
    sorterAgeDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        const dfa = a.statusId == 4 ? 0 : dspxDiffDays(a.doneDate, a.createTime) 
        const dfb = b.statusId == 4 ? 0 : dspxDiffDays(b.doneDate, b.createTime) 
        return  dfb - dfa
    },

    sorterStageLifeCycleAsc : (a, b) => {
        if (!a.stageAddressLifeCycle && b.stageAddressLifeCycle) return -1;
        if (a.stageAddressLifeCycle && !b.stageAddressLifeCycle) return 1;
        
        const aStage = a.stageAddressLifeCycle ? a.stageAddressLifeCycle.id : 0;
        const bStage = b.stageAddressLifeCycle ? b.stageAddressLifeCycle.id : 0;
    
        return aStage - bStage;
    },
    
    sorterStageLifeCycleDesc : (a, b) => {
        if (!a.stageAddressLifeCycle && b.stageAddressLifeCycle) return 1;
        if (a.stageAddressLifeCycle && !b.stageAddressLifeCycle) return -1;
    
        const aStage = a.stageAddressLifeCycle ? a.stageAddressLifeCycle.id : 0;
        const bStage = b.stageAddressLifeCycle ? b.stageAddressLifeCycle.id : 0;
    
        return bStage - aStage;
    },

    sorterStageLifeCycleCurrentAsc : (a, b) => {
        if (!a.stageAddressLifeCycleCurrent && b.stageAddressLifeCycleCurrent) return -1;
        if (a.stageAddressLifeCycleCurrent && !b.stageAddressLifeCycleCurrent) return 1;
        
        const aStage = a.stageAddressLifeCycleCurrent ? a.stageAddressLifeCycleCurrent.id : 0;
        const bStage = b.stageAddressLifeCycleCurrent ? b.stageAddressLifeCycleCurrent.id : 0;
    
        return aStage - bStage;
    },
    
    sorterStageLifeCycleCurrentDesc : (a, b) => {
        if (!a.stageAddressLifeCycleCurrent && b.stageAddressLifeCycleCurrent) return 1;
        if (a.stageAddressLifeCycleCurrent && !b.stageAddressLifeCycleCurrent) return -1;
    
        const aStage = a.stageAddressLifeCycleCurrent ? a.stageAddressLifeCycleCurrent.id : 0;
        const bStage = b.stageAddressLifeCycleCurrent ? b.stageAddressLifeCycleCurrent.id : 0;
    
        return bStage - aStage;
    },

    sorterAcceptanceLifeCycleAsc : (a, b) => {
        if (!a.acceptanceStatusAddressLifeCycle && b.acceptanceStatusAddressLifeCycle) return -1;
        if (a.acceptanceStatusAddressLifeCycle && !b.acceptanceStatusAddressLifeCycle) return 1;
        
        const aStage = a.acceptanceStatusAddressLifeCycle ? a.acceptanceStatusAddressLifeCycle.id : 0;
        const bStage = b.acceptanceStatusAddressLifeCycle ? b.acceptanceStatusAddressLifeCycle.id : 0;
    
        return aStage - bStage;
    },
    
    sorterAcceptanceLifeCycleDesc : (a, b) => {
        if (!a.acceptanceStatusAddressLifeCycle && b.acceptanceStatusAddressLifeCycle) return 1;
        if (a.acceptanceStatusAddressLifeCycle && !b.acceptanceStatusAddressLifeCycle) return -1;
    
        const aStage = a.acceptanceStatusAddressLifeCycle ? a.acceptanceStatusAddressLifeCycle.id : 0;
        const bStage = b.acceptanceStatusAddressLifeCycle ? b.acceptanceStatusAddressLifeCycle.id : 0;
    
        return bStage - aStage;
    },


    sorterExpiredAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;

        return dspxDiffDays(a.doneDate, a.executeTime) 
             - dspxDiffDays(b.doneDate, b.executeTime);
    },
    sorterExpiredDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;

        return dspxDiffDays(b.doneDate, b.executeTime) 
             - dspxDiffDays(a.doneDate, a.executeTime);
    },
    sorterDeadlineAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;

        return dspxDiffDays(a.doneDate, a.executeTime) 
             - dspxDiffDays(b.doneDate, b.executeTime);
    },
    sorterDeadlineDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;

        return dspxDiffDays(b.doneDate, b.executeTime) 
             - dspxDiffDays(a.doneDate, a.executeTime);
    },
    sorterCreateTimeAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        //return dspxDiffSeconds(a.createTime, b.createTime)
        return a.createTime.localeCompare(b.createTime)
    },
    sorterCreateTimeDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.createTime.localeCompare(a.createTime)
        //return dspxDiffSeconds(b.createTime, a.createTime)
    },
    sorterExecuteTimeAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return a.executeTime ? a.executeTime.localeCompare(b.executeTime) : 1;
        //return dspxDiffSeconds(a.executeTime, b.executeTime)
    },
    sorterExecuteTimeDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.executeTime ? b.executeTime.localeCompare(a.executeTime) : 1;
        //return dspxDiffSeconds(b.executeTime, a.executeTime)
    },
    sorterCloseDateAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return a.doneDate ? a.doneDate.localeCompare(b.doneDate) : 1;
        //return dspxDiffSeconds(a.executeTime, b.executeTime)
    },
    sorterCloseDateDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.doneDate ? b.doneDate.localeCompare(a.doneDate) : 1;
        //return dspxDiffSeconds(b.executeTime, a.executeTime)
    },
    // sorterControlDateAsc: (a, b) => {
    //     if (a.isImmediate !== b.isImmediate) {
    //         return a.isImmediate ? -1 : 1;
    //     }

    //     const aEmpty = !a.alertDateTime;
    //     const bEmpty = !b.alertDateTime;

    //     if (aEmpty && bEmpty) return 0;
    //     if (aEmpty) return -1;
    //     if (bEmpty) return 1;

    //     return a.alertDateTime.localeCompare(b.alertDateTime);
    // },
    // sorterControlDateDesc: (a, b) => {
    //     if (a.isImmediate !== b.isImmediate) {
    //         return a.isImmediate ? -1 : 1;
    //     }

    //     const aEmpty = !a.alertDateTime;
    //     const bEmpty = !b.alertDateTime;

    //     if (aEmpty && bEmpty) return 0;
    //     if (aEmpty) return 1;
    //     if (bEmpty) return -1;

    //     return b.alertDateTime.localeCompare(a.alertDateTime);
    // },
    sorterCloseNotDoneDateAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return a.closeDate ? a.closeDate.localeCompare(b.closeDate) : 1;
    },
    sorterCloseNotDoneDateDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        return b.closeDate ? b.closeDate.localeCompare(a.closeDate) : 1;
    },

  _sorterUrgency: (a, b, defaultValue) => {
    const fieldBySortedA = a?.priority?.code?.charCodeAt() || defaultValue;
    const fieldBySortedB = b?.priority?.code?.charCodeAt() || defaultValue;
    if (fieldBySortedA > fieldBySortedB) {
      return -1;
    }
    if (fieldBySortedA < fieldBySortedB) {
      return 1;
    }
    return 0;
  },

  sorterUrgencyAsc: (a, b) => {
    return dspxSorter._sorterUrgency(a, b, -Infinity);
  },

  sorterUrgencyDesc: (a, b) => {
    return dspxSorter._sorterUrgency(b, a, Infinity);
  },

  sorterAddressAsc: (a, b) => {
    if (b.isImmediate && !a.isImmediate) return 1;
    if (a.isImmediate && !b.isImmediate) return -1;
    return normalizeStr(a.fullAddress).localeCompare(
      normalizeStr(b.fullAddress),
      undefined,
      {
        numeric: true,
      }
    );
  },
  sorterAddressDesc: (a, b) => {
    if (b.isImmediate && !a.isImmediate) return 1;
    if (a.isImmediate && !b.isImmediate) return -1;
    return normalizeStr(b.fullAddress).localeCompare(
      normalizeStr(a.fullAddress),
      undefined,
      {
        numeric: true,
      }
    );
  },
    sorterMasterAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        const sa = a.master ? a.master.fullName : '';
        const sb = b.master ? b.master.fullName : '';
        return sa.localeCompare(sb);
    },
    sorterMasterDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        const sa = a.master ? a.master.fullName : '';
        const sb = b.master ? b.master.fullName : '';
        return sb.localeCompare(sa);
    },
    sorterServiceAsc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        const r = a.parentService.localeCompare(b.parentService);
        return r === 0 ? a.service.localeCompare(b.service) : r;
    },
    sorterServiceDesc : (a, b) => {
        if (b.isImmediate && !a.isImmediate) return 1;
        if (a.isImmediate && !b.isImmediate) return -1;
        const r = b.parentService.localeCompare(a.parentService);
        return r === 0 ? b.service.localeCompare(a.service) : r;
    },
    sorterLastUpdateTimeAsc : (a, b) => {
        //if (b.isImmediate && !a.isImmediate) return 1;
        //if (a.isImmediate && !b.isImmediate) return -1;
        const ad = a.lastChangeDateTime || a.createDateTime
        const bd = b.lastChangeDateTime || b.createDateTime
        return ad.localeCompare(bd)
    },
    sorterLastUpdateTimeDesc : (a, b) => {
        //if (b.isImmediate && !a.isImmediate) return 1;
        //if (a.isImmediate && !b.isImmediate) return -1;
        const ad = a.lastChangeDateTime || a.createDateTime
        const bd = b.lastChangeDateTime || b.createDateTime
        return bd.localeCompare(ad)
    },

}